import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useEffect } from 'react';
import './About.css';
import choose1 from '../Images/choose-1.png';
import choose2 from '../Images/choose-2.png';
import choose3 from '../Images/choose-3.png';
import choose4 from '../Images/choose-4.png';
import { useHistory } from 'react-router-dom';
import { sponsorsData } from './Products';
import { Helmet } from 'react-helmet';

function About() {
    const history = useHistory();

    useEffect(() => {
        history.push('/about');
    }, []);

    return (
        <>
            <div className="container-fluid about mt-3">
                <Helmet>
                    <meta name="description" content="Please contact us using this form if you face any problem. Our team will help you in any case..." />
                    <title>About | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="row">
                    <div className="aboutUs">
                        <div className="col-md-8 md-offset-2 mx-auto text-center">
                            <h3 className="elementor-heading-title elementor-size-default">About Us</h3>
                            <div className="elementor-widget-container text-center">
                                <p>At Kaipsool, we are the driving force behind the enhancement of the pharmaceutical industry. Established with a commitment to reshape the way pharmaceutical retailers and retail chain companies engage with their customers, we have become the go-to platform for unlocking new opportunities and enhancing brand presence.</p>
                            </div>
                        </div>
                    </div>
                    <div className="whoWeAre">
                        <div className="col-md-8 md-offset-2 mx-auto mt-5 row ourMissionRow text-center">
                            <h3 className="elementor-heading-title elementor-size-default heading__pading">Who We Are?</h3>
                            <div className="col-md-6">
                                <div className="elementor-widget-container">
                                    <p>We are a forward-thinking, cloud-based tech platform dedicated to making a positive impact in the pharma sector. Our mission is to empower businesses, improve patient access to medicines, and facilitate the success of pharma events.</p>
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                            <div className="col-md-4">
                                <div className="who-elementor-widget-image">
                                    <img src="https://butamepharma.com/wp-content/uploads/2023/09/michal-parzuchowski-7TWRwDjfGew-unsplash-scaled.jpg"  />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="whatWeDo aboutUs">
                        <div className="col-md-8 md-offset-2 mx-auto text-center">
                            <h3 className="elementor-heading-title elementor-size-default">What We Do?</h3>
                            <div className="col-md-12 md-offset-2 mx-auto row coreValueRow text-center">
                                <div className="col-md-6 doBox">
                                    <h6 className="elementor-heading-title elementor-size-default mb-4">Patient-centric medicine search</h6>
                                    <div className="elementor-widget-container">
                                        <p>Our platform takes precise patient locations into account, providing an unprecedented level of convenience. Patients can effortlessly search for medicine availability and discounts at medical stores near them, ensuring their healthcare needs are met with ease</p>
                                    </div>
                                </div>
                                <div className="col-md-6 doBox">
                                    <h6 className="elementor-heading-title elementor-size-default mb-4">Discounts and Convenience</h6>
                                    <div className="elementor-widget-container">
                                        <p>We believe in creating a win-win scenario. Not only do we make it easy for customers to find medicines, but we also enable pharmaceutical retailers to offer attractive discounts, strengthening customer relationships and loyalty.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 md-offset-2 mx-auto row coreValueRow text-center">
                                <div className="col-md-6 doBox">
                                    <h6 className="elementor-heading-title elementor-size-default mb-4">User-Friendly Store Profiles</h6>
                                    <div className="elementor-widget-container">
                                        <p>Our user-friendly platform empowers medical stores to create and manage their profiles effortlessly. With the ability to add multiple products and offer discounts, we help you attract more customers and grow your business.</p>
                                    </div>
                                </div>
                                <div className="col-md-6 doBox">
                                    <h6 className="elementor-heading-title elementor-size-default mb-4">Brand Presence and Marketing</h6>
                                    <div className="elementor-widget-container">
                                        <p> For pharmaceutical retailers and retail chain companies, we offer a unique channel to boost brand presence and marketing opportunities. Showcase your products, promotions, and services to a broader audience and increase brand recognition.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 md-offset-2 mx-auto row coreValueRow text-center">
                                <div className="col-md-6 doBox">
                                    <h6 className="elementor-heading-title elementor-size-default mb-4">Promoting Pharma Events and Health Camps</h6>
                                    <div className="elementor-widget-container">
                                        <p>Our platform takes precise patient locations into account, providing an unprecedented level of convenience. Patients can effortlessly search for medicine availability and discounts at medical stores near them, ensuring their healthcare needs are met with ease.</p>
                                    </div>
                                </div>
                                <div className="col-md-6 doBox">
                                    <h6 className="elementor-heading-title elementor-size-default mb-4">Pharma Event Management</h6>
                                    <div className="elementor-widget-container">
                                        <p>We specialize in executing successful pharma events. Whether it's a seminar, conference, healthy sports event, or health camp, we simplify the event management process, reducing costs and resource allocation.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="coreValue pb-5">
                        <h3 className="elementor-heading-title elementor-size-default text-center textDecrotion">Why Choose Us?</h3>
                        <div className="col-md-8 md-offset-2 mx-auto row coreValueRow text-center">
                            <div className="col-md-6">
                                <img src={choose1} alt="google" className="img-fluid login__btnChooseImage" />
                                <h6 className="elementor-heading-title elementor-size-default mt-3">Innovation</h6>
                                <div className="elementor-widget-container">
                                    <p>We're at the forefront of technological advancements in the pharmaceutical industry, ensuring that your business stays ahead of the curve.</p>
                                </div>
                            </div>
                            <div className="col-md-6 mll-5">
                                <img src={choose2} alt="google" className="img-fluid login__btnChooseImage" />
                                <h6 className="elementor-heading-title elementor-size-default mt-3">Community Building</h6>
                                <div className="elementor-widget-container">
                                    <p>We foster collaboration and engagement within the pharmaceutical community, creating a supportive ecosystem for all stakeholders.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 md-offset-2 mx-auto mt-5 row coreValueRow mt-5 text-center">
                            <div className="col-md-6">
                                <img src={choose3} alt="google" className="img-fluid login__btnChooseImage" />
                                <h6 className="elementor-heading-title elementor-size-default mt-3">Expertise</h6>
                                <div className="elementor-widget-container">
                                    <p>Our team brings in-depth knowledge and expertise in the pharmaceutical and event management sectors.</p>
                                </div>
                            </div>
                            <div className="col-md-6 mll-5">
                                <img src={choose4} alt="google" className="img-fluid login__btnChooseImage" />
                                <h6 className="elementor-heading-title elementor-size-default mt-3">Customer-Centric</h6>
                                <div className="elementor-widget-container">
                                    <p>Our focus is on enhancing the customer experience while helping businesses thrive.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About
